module.exports = __webpack_public_path__ + "img/github.d07188ee.svg";